import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/shell/Sidebar";
import { Topbar } from "@/components/shell/Topbar";
import { useAuthStore, selectIsAuthenticated } from "@/stores/auth";
import { useAssetsQuery, useJobsQuery, useMeQuery } from "@/lib/queries";
import type { User } from "@/lib/api";

export function AppLayout() {
  const isAuthed = useAuthStore(selectIsAuthenticated);
  const setUser = useAuthStore((s) => s.setUser);

  const meQuery = useMeQuery({ enabled: isAuthed });
  useEffect(() => {
    if (meQuery.data) setUser(meQuery.data as User);
  }, [meQuery.data, setUser]);

  const { items: assets } = useAssetsQuery({ enabled: isAuthed });
  const { items: jobs } = useJobsQuery({ enabled: isAuthed, refetchInterval: 5_000 });

  return (
    <div className="grid h-screen grid-cols-[232px_1fr] overflow-hidden max-md:grid-cols-1 max-md:grid-rows-[auto_1fr]">
      <Sidebar assetCount={assets.length} jobCount={jobs.length} />
      <div className="grid h-screen grid-rows-[64px_1fr] overflow-hidden">
        <Topbar />
        <main className="overflow-y-auto p-7 max-md:p-4">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
